<script>import { locale, timeZone } from "./global-store.js";
</script>

<tfoot
  ><tr
    ><td>
      <footer class="footer">
        Generated at {Intl.DateTimeFormat($locale, {
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          timeZoneName: "shortGeneric",
          timeZone: $timeZone
        }).format(new Date())}
      </footer>
    </td></tr
  ></tfoot
>

<style>
  tfoot tr td .footer {
    font-size: var(--report-footer-font-size);
    margin-top: 0.5em;
  }
  tfoot tr td {
    color: var(--section-onSurface-color);
  }
  tfoot td {
    padding: 1em;
  }
</style>
